import { Typography } from 'app/component-library-wave';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationList } from 'app/components/location-list';
import { CustomerSegmentPicker } from 'app/pages/customer-segment-picker/customer-segment-picker';
import styles from './location-picker.module.scss';

export const LocationPicker = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <main className={styles.locationSelectorContainer}>
      <Typography id="locationListHeader" className={styles.title} variant="headline5" component="h1">
        {t('features.locationBoundary.headline')}
      </Typography>
      <Typography className={styles.subTitle} variant="uiText1" component="p">
        {t('features.locationBoundary.select')}
      </Typography>
      <LocationList />
      <CustomerSegmentPicker variant={'enterprise'} />
    </main>
  );
};
